const forge = require('node-forge');

export function isA3Certificate(pemData) {
  try {
    const pemFormatted = `-----BEGIN CERTIFICATE-----\n${pemData}-----END CERTIFICATE-----`;

    const cert = forge.pki.certificateFromPem(pemFormatted);

    const policiesExt = cert.extensions.find((ext) => ext.id === '2.5.29.32');

    if (policiesExt && policiesExt.value) {
      const derBytes = forge.util.createBuffer(policiesExt.value, 'binary');
      const asn1 = forge.asn1.fromDer(derBytes);

      const isA3 = asn1.value.some((policy) => {
        const oid = forge.asn1.derToOid(policy.value[0].value);
        const a3Regex = /^2\.16\.76\.1\.2\.3\.\d+$/;
        return a3Regex.test(oid);
      });

      return isA3;
    }

    return false;
  } catch (err) {
    return false;
  }
}

export function isA4Certificate(pemData) {
  try {
    const pemFormatted = `-----BEGIN CERTIFICATE-----\n${pemData}-----END CERTIFICATE-----`;

    const cert = forge.pki.certificateFromPem(pemFormatted);

    const policiesExt = cert.extensions.find((ext) => ext.id === '2.5.29.32');

    if (policiesExt && policiesExt.value) {
      const derBytes = forge.util.createBuffer(policiesExt.value, 'binary');
      const asn1 = forge.asn1.fromDer(derBytes);

      const isA4 = asn1.value.some((policy) => {
        const oid = forge.asn1.derToOid(policy.value[0].value);
        const a3Regex = /^2\.16\.76\.1\.2\.4\.\d+$/;
        return a3Regex.test(oid);
      });

      return isA4;
    }

    return false;
  } catch (err) {
    return false;
  }
}
